<template>
<nav id="nav" class="navbar navbar-expand-lg fixed-top" :class="{solidNav: scrollPosition > 99}">
 <div class="container-fluid">
    <a class="navbar-brand" href="#">
      <img class="d-inline-block align-text-top" width="100" height="80"  src="img/Logoacswhite.png" />
     </a>
     <a class="navbar-brand">
        <h1 class="namaperusahaan">PT ADOFAGIO CINTA SEJATI</h1>
        <h5 class="namabidang1">Rental and Forklift Services</h5>
        <h5 class="namabidang2">Oil and Grease</h5>
    </a>
    <button
      class="navbar-toggler navbar-toggle-right"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="true"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse px-3 py-3 d-flex justify-content-end" active-class="active" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="/"><u>Home</u></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/#productAcs"><u>Products</u></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/#marketcarousel"><u>Services</u></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/#costumerACS"><u>Projects</u></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/ContactUSACS"><u>Contact Us</u></a>
          </li>
        </ul>
    </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",

data () {
    return {
      scrollPosition: null
    }
  },
    
methods: {
    updateScroll() {
       this.scrollPosition = window.scrollY
    }
},

mounted() {
    window.addEventListener('scroll', this.updateScroll);
},

}
</script>

<style>
.solidNav {
  position: fixed !important;
  background: #1F1F1F;
}

.navbar .navbar-collapse .navbar-nav ul {
  list-style: none;
  text-align: center;
}
.navbar .navbar-collapse .navbar-nav ul li {
  /* display: inline-block; */
}
.navbar .navbar-collapse ul li a u {
  text-decoration: none;
  color: #fff;
  text-align: center;
  width: 100px;
  display: inline-block;
  font-weight: 800;
  transition: all 0.2s ease-in-out;
}
.navbar .navbar-collapse ul li a,
.navbar .navbar-collapse ul li a:after,
.navbar .navbar-collapse ul li a:before {
  transition: all 0.25s;
}
.navbar .navbar-collapse ul li a u:hover {
  color: #ff0000;
}
.navbar .navbar-collapse ul li a u {
  position: relative;
}
.navbar .navbar-collapse ul li a u:after {
  position: absolute;
  top: 1.5rem;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 0%;
  content: "";
  color: transparent;
  background: rgb(255, 255, 255);
  height: 1px;
}
.navbar .navbar-collapse ul li a u:hover:after {
  width: 100%;
}
.navbar-brand :hover {
  color: #ff0000;
}

.navbar-brand {
  color: white;
}
.navbar-brand .nav-img {
  width: 10%;
}
.navbar-brand .namaperusahaan {
  margin-bottom: 1px;
  font-size: 20px;
  font-family: Montserrat;
  font-weight: bolder;
}

.navbar-brand .namabidang1 {
  margin-bottom: 1px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
}

.navbar-brand .namabidang2 {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
}
@media screen and (max-width: 768px) {
  /* .navbar-brand .nav-img {
    width: 10%;
    height: 10%;
  } */
.navbar-brand .namaperusahaan {
    font-size: 14px;
    font-weight: bolder;
  }

.navbar-brand .namabidang1 {
    font-size: 12px;
  }

.navbar-brand .namabidang2 {
    font-size: 12px;
  }
}
</style>
